/**
 * Created by rathompson on 9/30/22
 * File: RowExpansionToggle
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { classNames } from '@panwds/react-ui'
import { CaretRightIcon } from '@panwds/icons'

const RowExpansionToggle = ({ row = {} }) => {
  return (
    <button
      aria-label={row?.isExpanded ? 'Collapse row' : 'Expand row'}
      {...row?.getToggleRowExpandedProps({
        className:
          'tw-box-border tw-border-none tw-p-0 tw-m-0 focus:tw-outline-none focus:tw-ring tw-bg-transparent tw-rounded tw-mr-1',
      })}
      type='button'
    >
      <CaretRightIcon size='xs' className={classNames(
        'cm-text-gray-700 cm-transition-transform cm-duration-200',
        row?.isExpanded && 'cm-rotate-90',
      )} />
    </button>
  )
}

RowExpansionToggle.defaultProps = {
  row: {
    getToggleRowExpandedProps: () => []
  }
}
export default RowExpansionToggle
